module.exports = __webpack_public_path__ + "static/img/szafa_27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_27.svg
// module id = Nk3l
// module chunks = 0